import { SolutionType } from './solution.type';

export class SolutionArrayType {
	recommendedSolutions: Array<SolutionType>;

	constructor(recommendedSolutions: Array<SolutionType>) {
		this.recommendedSolutions = recommendedSolutions;
	}
}
